import React from 'react';

interface BrandLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showDomain?: boolean;
  className?: string;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({
  size = 'md',
  showDomain = false,
  className = ''
}) => {
  const sizeMap = {
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-12',
    xl: 'h-16 sm:h-20'
  };

  return (
    <div className={`inline-flex items-center gap-2 select-none ${className}`}>
      <img
        src="/ytklogo.jpg"
        alt="YeTryKar Logo"
        className={`${sizeMap[size]} w-auto object-contain rounded-md`}
      />

      {showDomain && (
        <span className="text-[10px] uppercase font-mono px-1.5 py-0.5 rounded bg-blue-50 text-blue-900 border border-blue-200/80 font-semibold tracking-wide ml-0.5">
          YeTryKar
        </span>
      )}
    </div>
  );
};
